import '../stylesheets/app.scss';

import { Collapse } from 'bootstrap';
import 'jquery.cycle2';

(function($) {

  $(document).ready(function() {

    // Swap the product image for the variation's own image, when it has one
    var $productSlideshow = $('.product-slideshow');

    if ( $productSlideshow.length ) {
      var $variationImage = $productSlideshow.find('.variation-image');
      var productImageId  = $productSlideshow.data('product-image-id');

      var resetVariationImage = function() {
        $variationImage.addClass('d-none').attr('src', '').attr('srcset', '');
        $productSlideshow.removeClass('showing-variation-image');
      };

      $('.variations_form').on('found_variation', function( event, variation ) {
        if ( variation.image_id && variation.image_id != productImageId && variation.image && variation.image.src ) {
          $variationImage
            .attr('src', variation.image.src)
            .attr('srcset', variation.image.srcset || '')
            .attr('sizes', variation.image.sizes || '')
            .attr('alt', variation.image.alt || '')
            .removeClass('d-none');
          $productSlideshow.addClass('showing-variation-image');
        } else {
          resetVariationImage();
        }
      }).on('reset_data hide_variation', resetVariationImage);
    }

  });

  // Pre select the first available date of the calendar on Mammoth Day Out product
  function loadFrame() {
    var availableDate = document.querySelectorAll("#product-11364 .wc-bookings-booking-form .wc-bookings-date-picker a.ui-state-default");
    if ( document.contains(availableDate[0]) ) {
      availableDate[0].click();
    }
  }
  window.onload = setTimeout(loadFrame, 1000);

})( jQuery );
